import { userActions } from './user.slice';

export const {
  setAccessToken,
  setRefreshToken,
  setIsEmailConfirmed,
  setAuthUser,
} = userActions;
